import type { SVGProps } from 'react'

export function BankCheck2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
      <path
        d="M5.34571 10.562H12.9979M10.1281 14.3887H5.34549M20.1743 4.95657L23.0439 7.82615M21.6084 6.39067L17.7822 10.2168M21.1305 12.6075V17.3901C21.1305 17.9186 20.7025 18.3467 20.174 18.3467H2.95653C2.42805 18.3467 2 17.9186 2 17.3901V6.86835C2 6.33987 2.42805 5.91183 2.95653 5.91183H15.3914M17.9034 12.6089H15.3911V10.0966C15.3911 9.84643 15.4906 9.60634 15.6676 9.42938L20.8204 4.27656C21.1891 3.90781 21.786 3.90781 22.1543 4.27656L23.7234 5.84574C24.0922 6.214 24.0922 6.81088 23.7234 7.17963L18.5706 12.3324C18.3937 12.5094 18.1536 12.6089 17.9034 12.6089Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
